import React, { useState } from "react";
import { useSelector } from "react-redux";
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import ConsolidateDashboardReport from "../../components/DashboardBox/DashboardComponents/ConsolidateDashboardReport";

const ConsolidateDashboard = () => {
  const { financialYears } = useSelector((state) => state.authData);
  const fy_list = financialYears.payload.fy_list;
  const [, setDivisionNumber] = useState(() => {
    const stored = localStorage.getItem("globalAmountDivisor");
    return stored ? Number(stored) : 1;
  });
  const [fyId, setFyId] = useState(() => localStorage.getItem("globalDateId"));

  const handlePageTrigger = () => {
    setFyId(localStorage.getItem("globalDateId"));
  };

  return (
    <>
      <SubHeader
        fy_list={fy_list}
        setDivisionNumber={setDivisionNumber}
        handlePageTrigger={handlePageTrigger}
      />
      <div className="row" style={{ padding: "10px 16px" }}>
        <div className="col-md-6">
          <h4 style={{ color: "#28326f", margin: 0 }}>Consolidate Dashboard</h4>
          <CustomBreadcrumbs linksArray={[]} title="Consolidate Dashboard" />
        </div>
      </div>
      <div className="overflow-x-hidden" style={{ backgroundColor: "#F1F1F1", padding: "0 8px" }}>
        <ConsolidateDashboardReport
          fyId={fyId}
          fy_list={fy_list}
          showDashboardLink
        />
      </div>
    </>
  );
};

export default ConsolidateDashboard;
